<div class="search-options flex flex-row flex-wrap gap-[25px] justify-start items-baseline">
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{ '+SEARCH.SEARCH_BY_ERROR.PLACEHOLDER' | translate }}</mat-label>
    <input
      data-at-error-code
      matInput
      required
      #errorCodeInput
      name="errorCode"
      [(ngModel)]="errorCode"
      (keyup.enter)="search()"
      gtm="onTextField"
      gtmId="error-code"
      gtmAction="Error code"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
      fieldTextContentTooltip
    />
    <mat-error *ngIf="errorCodeInput.required">{{
      '+SEARCH.SEARCH_BY_ERROR.OPTION_SEARCH.REQUIRED_ERROR_CODE_MESSAGE' | translate
    }}</mat-error>
    <button
      data-at-close-btn
      *ngIf="errorCode"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="Error search query"
      gtmCategory="search"
      gtmLabel="clearErrorCode"
      (click)="errorCode = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <form [formGroup]="formGroup" class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]">
    <mat-form-field mat-input-height-large-label class="!flex flex-[100%] max-w-[100%]">
      <mat-label>{{
        '+SEARCH.SEARCH_BY_ERROR.OPTION_SEARCH.PLACEHOLDER.BOILER_SERIAL' | translate
      }}</mat-label>
      <input
        data-at-material-number
        matInput
        required
        name="materialNumber"
        [formControl]="formGroup.controls.materialNumber"
        (keyup.enter)="search()"
        gtm="onTextField"
        gtmId="material-number"
        gtmAction="Material number"
        gtmCategory="search"
        [gtmOn]="['change', 'focus', 'blur']"
        fieldTextContentTooltip
      />
      <mat-error *ngIf="formGroup.controls.materialNumber.hasError('required')">
        {{ '+SEARCH.SEARCH_BY_ERROR.OPTION_SEARCH.REQUIRED_MATERIAL_NUMBER_MESSAGE' | translate }}
      </mat-error>
      <mat-error *ngIf="formGroup.controls.materialNumber.hasError('minlength')">
        {{ '+SEARCH.SEARCH_BY_ERROR.OPTION_SEARCH.MINLENGTH_MATERIAL_NUMBER_MESSAGE' | translate }}
      </mat-error>
      <button
        type="button"
        data-at-close-btn
        *ngIf="formGroup.controls.materialNumber.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        gtm="onClearSearch"
        gtmAction="Error search query"
        gtmCategory="search"
        gtmLabel="clearMaterialNumber"
        (click)="formGroup.controls.materialNumber.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </form>

  <mat-form-field
    mat-select-height-large
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_ERROR.OPTION_SEARCH.PLACEHOLDER.COUNTRY' | translate
    }}</mat-label>
    <mat-select
      data-at-country
      required
      [value]="selectedCountry"
      (valueChange)="selectedCountry = $event"
      fieldTextContentTooltip
    >
      <mat-option
        *ngFor="let country of countries"
        [value]="country"
        gtm="onSelect"
        gtmAction="Error country"
        gtmCategory="search"
        fieldTextContentTooltip
      >
        {{ searchService.transformCountryCodeToUpperCase(country) | country | translate }}
        <span *ngIf="getLanguage(country)">({{ getLanguage(country) | translate }})</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="button-wrapper flex flex-row justify-end items-center">
  <button
    mat-stroked-button
    color="primary"
    gtm="onClearSearch"
    gtmAction="Error search query"
    gtmCategory="search"
    (click)="clear()"
  >
    {{ 'GENERAL.BUTTON.CLEAR' | translate }}
  </button>
  <button
    disabled
    mat-raised-button
    color="primary"
    gtm="onSearch"
    gtmAction="Error"
    gtmCategory="search"
    (click)="search()"
    [class.disabled]="formGroup.invalid || !errorCode"
    [disabled]="formGroup.invalid || !errorCode"
  >
    {{ 'GENERAL.BUTTON.SEARCH' | translate }}
  </button>
</div>
